
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/google-search-ads-360",
      function () {
        return require("private-next-pages/destinations/google-search-ads-360.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/google-search-ads-360"])
      });
    }
  